import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { OptimizedImage } from "@/components/OptimizedImage";
import whyWeCareBackground from "@/assets/why-we-care-background.jpg";

export const WhyWeCare = () => {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <OptimizedImage
          src={whyWeCareBackground}
          alt=""
          decorative
          className="w-full h-full object-cover"
          width={1920}
          height={1080}
        />
        <div className="absolute inset-0 bg-black/65"></div>
      </div>

      <div className="container mx-auto px-4 max-w-3xl text-center relative z-10">
        <div className="w-14 h-14 mx-auto mb-6 rounded-full flex items-center justify-center" style={{
          backgroundColor: 'hsl(350 70% 45% / 0.3)',
          border: '2px solid hsl(350 70% 65%)'
        }}>
          <Heart className="h-7 w-7" style={{ color: 'hsl(350 70% 75%)' }} />
        </div>
        
        <h2 className="font-display text-3xl md:text-4xl mb-6 text-white tracking-tight">
          Why We Care So Much About <span style={{ color: 'hsl(350 70% 70%)' }}>Small Business</span>
        </h2>
        
        <p className="text-white/80 text-base md:text-lg leading-relaxed mb-4">
          Our passion for small business is personal. Entrepreneurship gave our family flexibility during a hard season, and it deepened our respect for the risk, responsibility, and resilience it takes to build something of your own.
        </p>
        
        <p className="text-white font-semibold text-lg md:text-xl mb-4">
          We believe small business is the backbone of this country.
        </p>
        
        <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8">
          That's why we built Hollins &amp; Hur around what business owners actually need: proactive accounting, year-round tax strategy, fractional CFO support, and timely financial insight that gives you more clarity, confidence, and peace of mind.
        </p>

        <Link to="/consultation">
          <Button size="lg" className="text-base px-8 py-5 h-auto text-white border-0" style={{
            backgroundColor: 'hsl(350 70% 45%)'
          }}>
            Book a Free Discovery Call Now
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </Link>
      </div>
    </section>
  );
};
